// src/IconArrowUpRightFill.tsx
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var Icon = ({
  size = 24,
  ...props
}, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-seed-icon": "true",
    "data-seed-icon-version": "0.0.21",
    width: size,
    height: size,
    ref,
    ...props,
    children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.79999 3.99999C4.79999 3.33725 5.33725 2.79999 5.99999 2.79999H20C20.6627 2.79999 21.2 3.33725 21.2 3.99999V18C21.2 18.6627 20.6627 19.2 20 19.2C19.3372 19.2 18.8 18.6627 18.8 18V6.90905L4.84815 20.8489C4.37932 21.3173 3.61952 21.317 3.15109 20.8482C2.68267 20.3793 2.68299 19.6195 3.15183 19.1511L17.1149 5.19999H5.99999C5.33725 5.19999 4.79999 4.66273 4.79999 3.99999Z",
        fill: "currentColor"
      }
    ) })
  }
);
var IconArrowUpRightFill = forwardRef(Icon);
var IconArrowUpRightFill_default = IconArrowUpRightFill;
export {
  IconArrowUpRightFill_default as default
};
